import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  AnnouncementsOverviewBaseComponent,
  IAnnouncementsState,
  BreadcrumbItem,
} from '@resident-nx/shared';
import { ROUTE } from '../../../models';
import { filter, take } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { LoaderWebComponent } from '@resident-nx/web/ui';
import { InfiniteScrollWebComponent } from '../../atoms/infinite-scroll/infinite-scroll.component';
import { ContentCardWebComponent } from '../content-card/content-card.component';
import { BreadcrumbsWebComponent } from '../../atoms/breadcrumbs/breadcrumbs.component';

@Component({
  standalone: true,
  selector: 'rs-web-announcements-overview',
  templateUrl: './announcements-overview.component.html',
  styleUrls: ['./announcements-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BreadcrumbsWebComponent,
    ContentCardWebComponent,
    InfiniteScrollWebComponent,
    LoaderWebComponent,
    AsyncPipe,
    TranslateModule,
  ],
})
export class AnnouncementsOverviewWebComponent extends AnnouncementsOverviewBaseComponent {
  public breadcrumbs: BreadcrumbItem[] = [
    {
      label: 'main_navigation_news_l',
      url: ROUTE.NEWS,
    },
    {
      label: 'news.announcements_l',
      url: `${ROUTE.NEWS}/${ROUTE.ANNOUNCEMENTS}`,
    },
  ];

  constructor(
    private router: Router,
    announcementsStore: Store<IAnnouncementsState>
  ) {
    super(announcementsStore, 30);
  }

  public onNavigate(event: string = ROUTE.NEWS) {
    this.router.navigate([event]);
  }

  public onTapArticle(id: string) {
    this.router.navigate([ROUTE.NEWS, ROUTE.ANNOUNCEMENTS, id]);
  }

  public onScroll() {
    this.announcementsActionState$
      .pipe(
        filter(state => !state.pending),
        take(1)
      )
      .subscribe(() => this.loadMoreAnnouncements());
  }
}
